import axios from 'axios';

export default function setAuthorizationToken(token) {
  if (token) {
    axios.defaults.headers.common['authorization'] = `${token}`;
    if(localStorage.getItem('admin_token')){
      axios.defaults.headers.common['x-custom-admin-token'] = localStorage.getItem('admin_token');
    } else{
      delete axios.defaults.headers.common['x-custom-admin-token']
    }
  } else {
    delete axios.defaults.headers.common['authorization'];
  }
}



// WEBPACK FOOTER //
// ./src/utils/setAuthorizationToken.js